import React, { useId } from "react";
import PropTypes from "prop-types";

const paths = [
  "M17.8061 14.8372C17.9224 14.9064 18.0661 14.9875 18.2287 15.0793C18.9415 15.4814 20.019 16.0893 20.7572 16.8118C21.2189 17.2637 21.6575 17.8592 21.7373 18.5888C21.8221 19.3646 21.4836 20.0927 20.8046 20.7396C19.6332 21.8556 18.2274 22.75 16.4091 22.75H7.5908C5.77249 22.75 4.36671 21.8556 3.19526 20.7396C2.51624 20.0927 2.17778 19.3646 2.26258 18.5888C2.34233 17.8592 2.78098 17.2637 3.24265 16.8118C3.98082 16.0893 5.05833 15.4814 5.77114 15.0793C5.9338 14.9875 6.07749 14.9064 6.1938 14.8372C9.74785 12.7209 14.252 12.7209 17.8061 14.8372Z",
  "M6.74993 6.5C6.74993 3.6005 9.10044 1.25 11.9999 1.25C14.8994 1.25 17.2499 3.6005 17.2499 6.5C17.2499 9.39949 14.8994 11.75 11.9999 11.75C9.10044 11.75 6.74993 9.39949 6.74993 6.5Z",
];

const gradient = { x1: "20.4001", y1: "5.66516", x2: "3.88862", y2: "21.0921" };

const LoyalApplicantsIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const gradientIds = paths.map((_, i) => `loyal-applicants-gradient-${i}-${id}`);

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={selected ? undefined : "0.5"}>
        {paths.map((pathD, i) => (
          <path key={i} d={pathD} fill={`url(#${gradientIds[i]})`} />
        ))}
      </g>
      <defs>
        {gradientIds.map((gId) => (
          <linearGradient key={gId} id={gId} {...gradient} gradientUnits="userSpaceOnUse">
            <stop stopColor="#D946EF" />
            <stop offset="1" stopColor="#67E8F9" />
          </linearGradient>
        ))}
      </defs>
    </svg>
  );
};

LoyalApplicantsIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

LoyalApplicantsIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default LoyalApplicantsIcon;
